import VideoTiles from './VideoTiles.vue';
import VideoTile from './VideoTile.vue';
import VideoSquareTile from './VideoSquareTile.vue';
import VideoRectangleTile from './VideoRectangleTile.vue';
import VideoModal from './VideoModal.vue';
import Video from './Video.vue';
import state from './state/VideoTiles';
import VueHead from 'vue-head';

// We are intentionally exposing components that *may* be required by the bundle-consumer
// Source-code-consumers like odds.com.au can directly import modules, so are not affected
export default {
  VideoTiles,
  VideoTile,
  VideoSquareTile,
  VideoRectangleTile,
  VideoModal,
  Video,
  state,
  VueHead,
};
